var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 38.4,
    viewBox: "0 0 27 38.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M89.5,0A13.5,13.5,0,0,0,78.015,20.6L88.732,37.868a1.125,1.125,0,0,0,.956.532H89.7a1.125,1.125,0,0,0,.956-.547L101.1,20.417A13.5,13.5,0,0,0,89.5,0Zm9.665,19.261L89.67,35.114l-9.743-15.7a11.258,11.258,0,1,1,19.237-.152Z",
    transform: "translate(-76 0)",
    fill: "#263a4b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(6.75 6.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M172.75,90a6.75,6.75,0,1,0,6.75,6.75A6.758,6.758,0,0,0,172.75,90Zm0,11.265a4.515,4.515,0,1,1,4.508-4.515A4.518,4.518,0,0,1,172.75,101.265Z",
    transform: "translate(-166 -90)",
    fill: "#263a4b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactpin);
export default __webpack_public_path__ + "static/media/contactpin.2154b9aa02e2cfb55ec44e9e7b931358.svg";
export { ForwardRef as ReactComponent };